import crossingSvg from '../../../assets/crossing.svg';

const CrossingIcon = () => {
    return (
        <div className="flex flex-wrap items-center gap-4">
            <img 
                src={crossingSvg} 
                alt='Crossing icon' 
                className="w-10 h-10"
            />
        </div>
    );
}

export default CrossingIcon;